import { get } from 'svelte/store';
import { DEBUG_CONFIG } from '../mapConstants';

// Debug category type
export type DebugCategory = 'containerDetection' | 'shapeMatching' | 'floorChanges' | 'svgUpdates';

/**
 * Log a debug message if the corresponding category is enabled
 */
export function debugLog(message: string, category: DebugCategory): void {
  const config = get(DEBUG_CONFIG);
  // Don't log anything if master toggle is off, regardless of category
  if (!config.showDebugPanels) {
    return;
  }
  
  const shouldLog = 
    (category === 'containerDetection' && config.logContainerDetection) ||
    (category === 'shapeMatching' && config.logShapeMatching) ||
    (category === 'floorChanges' && config.logFloorChanges) ||
    (category === 'svgUpdates' && config.logSvgUpdates);
  
  if (shouldLog) {
    console.log(message);
  }
}

/**
 * Log a warning message if debug mode is enabled
 */
export function debugWarn(message: string, error?: any): void {
  const config = get(DEBUG_CONFIG);
  // Only show warnings if debug mode is enabled
  if (!config.showDebugPanels) {
    return;
  }
  
  if (error) {
    console.warn(message, error);
  } else {
    console.warn(message);
  }
} 